<template>
  <div>
  
    <div class="producer-logo-container" style="height:20px;">
      <img :src="getLogoName" :alt="getLogoName">
    </div>

    <div class="table-cell" style="width: 100px; height:20px;">{{getI18n(observation.producer.name,"en")}}</div>
    <div class="table-cell" style="width: 150px; height:20px;">
      <div v-if="observation.observation.featureOfInterest.samplingFeature.name != null">
        {{getI18n(observation.observation.featureOfInterest.samplingFeature.name,"en")}}
      </div>
    </div>
    <div class="table-cell" style="width: 175px; height:20px;">{{getI18n(observation.dataset.metadata.title,"en")}}</div>
    <div class="table-cell" style="width: 350px; height:20px;">
      {{getI18n(observation.observation.observedProperty.name,"en")}}
      ({{getI18n(observation.observation.observedProperty.unit,"en")}})</div>    
    <div class="show-detail ui button" @click.stop="showDetails">
      <i class="info icon"></i> Show details
    </div>
  </div>
</template>

<style>
.show-detail.ui.button {
  float: right;
  font-size: 12px;
  padding: 5px;
}
.producer-logo-container img {
  height: 20px;
}
.producer-logo-container {
  float:left;
  width: 25px;
}
.table-cell {
  overflow:hidden;
  float:left;
  width: 100px;
  margin-left: 10px;
  font-size:12px;
}

</style>



<script>
import { mapActions, mapGetters } from "vuex";

export default {
  props: ["observation"],
  computed: {
    /**
     * Vuex observation store getter
     */
    ...mapGetters(["getObservationsDetailed"]),
    /**
     * Build the relative path of the producer logo to be printed
     */
    getLogoName() {
      return (
        "/assets/images/" +
        this.observation.producer.producerId +
        ".png"
      );
    }
  },
  watch: {
    /**
     * When Vuex observation store getter getObservationsDetailed is modified
     * "showObservationMetadata" event is emitted to the root component. This event is listened by
     * info-panel-component.vue to print detailed observation information.
     * ------------------------
     * Event bus - better use Vuex Store
     */
    getObservationsDetailed() {
      this.$root.$emit("showObservationMetadata");
    }
  },
  mounted() {
    this.modifyElementId();
  },
  updated() {
    this.modifyElementId();
  },
  methods: {
    /**
     * Modify id of the DOM element to be a string that can be parsed into JSON
     */
    modifyElementId() {
      let idString = "[";
      this.observation.documentId.forEach(item => {
        idString = idString + '"' + item + '",';
      });
      idString = idString.substring(0, idString.length - 1) + "]";
      this.$el.id = idString;
    },

    /**
     * Actions
     */
    ...mapActions({
      setObservationsDetailed: "setObservationsDetailed"
    }),

    /**
     * Getters
     */
    getI18n(el, lang) {
      let tmp = el.find(element => element.lang === lang);
      return tmp.text;
    },

    /**
     * Method to show the detail information about the observation
     */
    showDetails() {
      this.setObservationsDetailed(this.$el.id);
    }
  }
};
</script>